/**
 * US States (50 + DC) and USA DMAs for campaign geo targeting.
 * States use ISO 3166-2 (US-XX). DMAs use "DMA:Name" for storage.
 */

/** Whole-country option (selectable in typeahead) */
export const UNITED_STATES_OPTION = { label: "United States", code: "US", type: "country" };

export const US_STATES = [
  { label: "Alabama", code: "US-AL" },
  { label: "Alaska", code: "US-AK" },
  { label: "Arizona", code: "US-AZ" },
  { label: "Arkansas", code: "US-AR" },
  { label: "California", code: "US-CA" },
  { label: "Colorado", code: "US-CO" },
  { label: "Connecticut", code: "US-CT" },
  { label: "Delaware", code: "US-DE" },
  { label: "District of Columbia", code: "US-DC" },
  { label: "Florida", code: "US-FL" },
  { label: "Georgia", code: "US-GA" },
  { label: "Hawaii", code: "US-HI" },
  { label: "Idaho", code: "US-ID" },
  { label: "Illinois", code: "US-IL" },
  { label: "Indiana", code: "US-IN" },
  { label: "Iowa", code: "US-IA" },
  { label: "Kansas", code: "US-KS" },
  { label: "Kentucky", code: "US-KY" },
  { label: "Louisiana", code: "US-LA" },
  { label: "Maine", code: "US-ME" },
  { label: "Maryland", code: "US-MD" },
  { label: "Massachusetts", code: "US-MA" },
  { label: "Michigan", code: "US-MI" },
  { label: "Minnesota", code: "US-MN" },
  { label: "Mississippi", code: "US-MS" },
  { label: "Missouri", code: "US-MO" },
  { label: "Montana", code: "US-MT" },
  { label: "Nebraska", code: "US-NE" },
  { label: "Nevada", code: "US-NV" },
  { label: "New Hampshire", code: "US-NH" },
  { label: "New Jersey", code: "US-NJ" },
  { label: "New Mexico", code: "US-NM" },
  { label: "New York", code: "US-NY" },
  { label: "North Carolina", code: "US-NC" },
  { label: "North Dakota", code: "US-ND" },
  { label: "Ohio", code: "US-OH" },
  { label: "Oklahoma", code: "US-OK" },
  { label: "Oregon", code: "US-OR" },
  { label: "Pennsylvania", code: "US-PA" },
  { label: "Rhode Island", code: "US-RI" },
  { label: "South Carolina", code: "US-SC" },
  { label: "South Dakota", code: "US-SD" },
  { label: "Tennessee", code: "US-TN" },
  { label: "Texas", code: "US-TX" },
  { label: "Utah", code: "US-UT" },
  { label: "Vermont", code: "US-VT" },
  { label: "Virginia", code: "US-VA" },
  { label: "Washington", code: "US-WA" },
  { label: "West Virginia", code: "US-WV" },
  { label: "Wisconsin", code: "US-WI" },
  { label: "Wyoming", code: "US-WY" },
];

/** USA DMAs (Designated Market Areas) - major markets; code used for storage */
export const US_DMAS = [
  { label: "New York, NY", code: "DMA:New York, NY" },
  { label: "Los Angeles, CA", code: "DMA:Los Angeles, CA" },
  { label: "Chicago, IL", code: "DMA:Chicago, IL" },
  { label: "Philadelphia, PA", code: "DMA:Philadelphia, PA" },
  { label: "Dallas-Ft. Worth, TX", code: "DMA:Dallas-Ft. Worth, TX" },
  { label: "San Francisco-Oak-San Jose, CA", code: "DMA:San Francisco-Oak-San Jose, CA" },
  { label: "Washington, DC", code: "DMA:Washington, DC" },
  { label: "Houston, TX", code: "DMA:Houston, TX" },
  { label: "Boston, MA", code: "DMA:Boston, MA" },
  { label: "Atlanta, GA", code: "DMA:Atlanta, GA" },
  { label: "Phoenix, AZ", code: "DMA:Phoenix, AZ" },
  { label: "Tampa-St. Pete, FL", code: "DMA:Tampa-St. Pete, FL" },
  { label: "Seattle-Tacoma, WA", code: "DMA:Seattle-Tacoma, WA" },
  { label: "Detroit, MI", code: "DMA:Detroit, MI" },
  { label: "Minneapolis-St. Paul, MN", code: "DMA:Minneapolis-St. Paul, MN" },
  { label: "Miami-Ft. Lauderdale, FL", code: "DMA:Miami-Ft. Lauderdale, FL" },
  { label: "Denver, CO", code: "DMA:Denver, CO" },
  { label: "Orlando-Daytona Beach, FL", code: "DMA:Orlando-Daytona Beach, FL" },
  { label: "Cleveland, OH", code: "DMA:Cleveland, OH" },
  { label: "Sacramento-Stockton, CA", code: "DMA:Sacramento-Stockton, CA" },
  { label: "St. Louis, MO", code: "DMA:St. Louis, MO" },
  { label: "Portland, OR", code: "DMA:Portland, OR" },
  { label: "Baltimore, MD", code: "DMA:Baltimore, MD" },
  { label: "Charlotte, NC", code: "DMA:Charlotte, NC" },
  { label: "San Diego, CA", code: "DMA:San Diego, CA" },
  { label: "Indianapolis, IN", code: "DMA:Indianapolis, IN" },
  { label: "Hartford-New Haven, CT", code: "DMA:Hartford-New Haven, CT" },
  { label: "Raleigh-Durham, NC", code: "DMA:Raleigh-Durham, NC" },
  { label: "Nashville, TN", code: "DMA:Nashville, TN" },
  { label: "Milwaukee, WI", code: "DMA:Milwaukee, WI" },
  { label: "San Antonio, TX", code: "DMA:San Antonio, TX" },
  { label: "Cincinnati, OH", code: "DMA:Cincinnati, OH" },
  { label: "Kansas City, MO", code: "DMA:Kansas City, MO" },
  { label: "Columbus, OH", code: "DMA:Columbus, OH" },
  { label: "Austin, TX", code: "DMA:Austin, TX" },
  { label: "Las Vegas, NV", code: "DMA:Las Vegas, NV" },
  { label: "Pittsburgh, PA", code: "DMA:Pittsburgh, PA" },
  { label: "Norfolk-Portsmouth, VA", code: "DMA:Norfolk-Portsmouth, VA" },
  { label: "Greenville-Spartanburg, SC", code: "DMA:Greenville-Spartanburg, SC" },
  { label: "Salt Lake City, UT", code: "DMA:Salt Lake City, UT" },
  { label: "Birmingham, AL", code: "DMA:Birmingham, AL" },
  { label: "Memphis, TN", code: "DMA:Memphis, TN" },
  { label: "Oklahoma City, OK", code: "DMA:Oklahoma City, OK" },
  { label: "Louisville, KY", code: "DMA:Louisville, KY" },
  { label: "New Orleans, LA", code: "DMA:New Orleans, LA" },
  { label: "Buffalo, NY", code: "DMA:Buffalo, NY" },
  { label: "Providence, RI", code: "DMA:Providence, RI" },
  { label: "Jacksonville, FL", code: "DMA:Jacksonville, FL" },
  { label: "Richmond, VA", code: "DMA:Richmond, VA" },
  { label: "Raleigh-Durham, NC", code: "DMA:Raleigh-Durham, NC" },
  { label: "Grand Rapids-Kalamazoo, MI", code: "DMA:Grand Rapids-Kalamazoo, MI" },
  { label: "Harrisburg-Lancaster, PA", code: "DMA:Harrisburg-Lancaster, PA" },
  { label: "Albuquerque-Santa Fe, NM", code: "DMA:Albuquerque-Santa Fe, NM" },
  { label: "Wilkes Barre-Scranton, PA", code: "DMA:Wilkes Barre-Scranton, PA" },
  { label: "Fresno-Visalia, CA", code: "DMA:Fresno-Visalia, CA" },
  { label: "Little Rock-Pine Bluff, AR", code: "DMA:Little Rock-Pine Bluff, AR" },
  { label: "Albany-Schenectady-Troy, NY", code: "DMA:Albany-Schenectady-Troy, NY" },
  { label: "Tulsa, OK", code: "DMA:Tulsa, OK" },
  { label: "Florence-Myrtle Beach, SC", code: "DMA:Florence-Myrtle Beach, SC" },
  { label: "Honolulu, HI", code: "DMA:Honolulu, HI" },
  { label: "Tucson, AZ", code: "DMA:Tucson, AZ" },
  { label: "Omaha, NE", code: "DMA:Omaha, NE" },
  { label: "Wichita-Hutchinson, KS", code: "DMA:Wichita-Hutchinson, KS" },
  { label: "Greensboro-Winston Salem, NC", code: "DMA:Greensboro-Winston Salem, NC" },
  { label: "Des Moines-Ames, IA", code: "DMA:Des Moines-Ames, IA" },
  { label: "Spokane, WA", code: "DMA:Spokane, WA" },
  { label: "Rochester, NY", code: "DMA:Rochester, NY" },
  { label: "Knoxville, TN", code: "DMA:Knoxville, TN" },
  { label: "Paducah-Cape Girardeau, KY", code: "DMA:Paducah-Cape Girardeau, KY" },
  { label: "Mobile-Pensacola, AL", code: "DMA:Mobile-Pensacola, AL" },
  { label: "Green Bay-Appleton, WI", code: "DMA:Green Bay-Appleton, WI" },
  { label: "Toledo, OH", code: "DMA:Toledo, OH" },
  { label: "Charleston-Huntington, WV", code: "DMA:Charleston-Huntington, WV" },
  { label: "Madison, WI", code: "DMA:Madison, WI" },
  { label: "Ft. Myers-Naples, FL", code: "DMA:Ft. Myers-Naples, FL" },
  { label: "Tri-Cities, TN-VA", code: "DMA:Tri-Cities, TN-VA" },
  { label: "Lexington, KY", code: "DMA:Lexington, KY" },
  { label: "Wichita Falls, TX", code: "DMA:Wichita Falls, TX" },
  { label: "Cedar Rapids-Waterloo, IA", code: "DMA:Cedar Rapids-Waterloo, IA" },
  { label: "Savannah, GA", code: "DMA:Savannah, GA" },
  { label: "Champaign-Springfield, IL", code: "DMA:Champaign-Springfield, IL" },
  { label: "South Bend-Elkhart, IN", code: "DMA:South Bend-Elkhart, IN" },
  { label: "Portland-Auburn, ME", code: "DMA:Portland-Auburn, ME" },
  { label: "Springfield, MO", code: "DMA:Springfield, MO" },
  { label: "Colorado Springs-Pueblo, CO", code: "DMA:Colorado Springs-Pueblo, CO" },
  { label: "Columbia, SC", code: "DMA:Columbia, SC" },
  { label: "Harlingen-Weslaco, TX", code: "DMA:Harlingen-Weslaco, TX" },
  { label: "Baton Rouge, LA", code: "DMA:Baton Rouge, LA" },
  { label: "El Paso, TX", code: "DMA:El Paso, TX" },
  { label: "Charleston, SC", code: "DMA:Charleston, SC" },
  { label: "Syracuse, NY", code: "DMA:Syracuse, NY" },
  { label: "Flint-Saginaw-Bay City, MI", code: "DMA:Flint-Saginaw-Bay City, MI" },
  { label: "Boise, ID", code: "DMA:Boise, ID" },
  { label: "Davenport-Rock Island-Moline, IL", code: "DMA:Davenport-Rock Island-Moline, IL" },
  { label: "W Palm Beach-Ft. Pierce, FL", code: "DMA:W Palm Beach-Ft. Pierce, FL" },
  { label: "Corpus Christi, TX", code: "DMA:Corpus Christi, TX" },
  { label: "Youngstown, OH", code: "DMA:Youngstown, OH" },
  { label: "Reno, NV", code: "DMA:Reno, NV" },
  { label: "Columbus, GA", code: "DMA:Columbus, GA" },
  { label: "Peoria-Bloomington, IL", code: "DMA:Peoria-Bloomington, IL" },
  { label: "Burlington, VT", code: "DMA:Burlington, VT" },
  { label: "Wilmington, NC", code: "DMA:Wilmington, NC" },
  { label: "Monterey-Salinas, CA", code: "DMA:Monterey-Salinas, CA" },
  { label: "Fargo-Valley City, ND", code: "DMA:Fargo-Valley City, ND" },
  { label: "Lansing, MI", code: "DMA:Lansing, MI" },
  { label: "Palm Springs, CA", code: "DMA:Palm Springs, CA" },
  { label: "Tyler-Longview, TX", code: "DMA:Tyler-Longview, TX" },
  { label: "Amarillo, TX", code: "DMA:Amarillo, TX" },
  { label: "Shreveport, LA", code: "DMA:Shreveport, LA" },
  { label: "Lafayette, LA", code: "DMA:Lafayette, LA" },
  { label: "Tallahassee, FL", code: "DMA:Tallahassee, FL" },
  { label: "Bakersfield, CA", code: "DMA:Bakersfield, CA" },
  { label: "Augusta, GA", code: "DMA:Augusta, GA" },
  { label: "Columbus-Tupelo, MS", code: "DMA:Columbus-Tupelo, MS" },
  { label: "Chattanooga, TN", code: "DMA:Chattanooga, TN" },
  { label: "Greenville-New Bern-Washington, NC", code: "DMA:Greenville-New Bern-Washington, NC" },
  { label: "Evansville, IN", code: "DMA:Evansville, IN" },
  { label: "Lincoln-Hastings-Kearney, NE", code: "DMA:Lincoln-Hastings-Kearney, NE" },
  { label: "Santa Barbara-Santa Maria, CA", code: "DMA:Santa Barbara-Santa Maria, CA" },
  { label: "Traverse City-Cadillac, MI", code: "DMA:Traverse City-Cadillac, MI" },
  { label: "Laredo, TX", code: "DMA:Laredo, TX" },
  { label: "Lubbock, TX", code: "DMA:Lubbock, TX" },
  { label: "Anchorage, AK", code: "DMA:Anchorage, AK" },
  { label: "Eugene, OR", code: "DMA:Eugene, OR" },
  { label: "Fayetteville, AR", code: "DMA:Fayetteville, AR" },
  { label: "Sioux Falls, SD", code: "DMA:Sioux Falls, SD" },
  { label: "Macon, GA", code: "DMA:Macon, GA" },
  { label: "Lafayette, IN", code: "DMA:Lafayette, IN" },
  { label: "Montgomery, AL", code: "DMA:Montgomery, AL" },
  { label: "Huntsville-Decatur, AL", code: "DMA:Huntsville-Decatur, AL" },
  { label: "Fort Wayne, IN", code: "DMA:Fort Wayne, IN" },
  { label: "Waco-Temple-Bryan, TX", code: "DMA:Waco-Temple-Bryan, TX" },
  { label: "Biloxi-Gulfport, MS", code: "DMA:Biloxi-Gulfport, MS" },
  { label: "Beaumont-Port Arthur, TX", code: "DMA:Beaumont-Port Arthur, TX" },
  { label: "Myrtle Beach-Florence, SC", code: "DMA:Myrtle Beach-Florence, SC" },
  { label: "Yakima-Pasco-Richland-Kennewick, WA", code: "DMA:Yakima-Pasco-Richland-Kennewick, WA" },
  { label: "Rochester, MN", code: "DMA:Rochester, MN" },
  { label: "Duluth, MN", code: "DMA:Duluth, MN" },
  { label: "Wichita, KS", code: "DMA:Wichita, KS" },
  { label: "Abilene-Sweetwater, TX", code: "DMA:Abilene-Sweetwater, TX" },
  { label: "San Angelo, TX", code: "DMA:San Angelo, TX" },
  { label: "Odessa-Midland, TX", code: "DMA:Odessa-Midland, TX" },
  { label: "Erie, PA", code: "DMA:Erie, PA" },
  { label: "Topeka, KS", code: "DMA:Topeka, KS" },
  { label: "Joplin-Pittsburg, MO", code: "DMA:Joplin-Pittsburg, MO" },
  { label: "Quincy-Hannibal-Keokuk, IL", code: "DMA:Quincy-Hannibal-Keokuk, IL" },
  { label: "Medford-Klamath Falls, OR", code: "DMA:Medford-Klamath Falls, OR" },
  { label: "Bend, OR", code: "DMA:Bend, OR" },
  { label: "Idaho Falls-Pocatello, ID", code: "DMA:Idaho Falls-Pocatello, ID" },
  { label: "Billings, MT", code: "DMA:Billings, MT" },
  { label: "Great Falls, MT", code: "DMA:Great Falls, MT" },
  { label: "Missoula, MT", code: "DMA:Missoula, MT" },
  { label: "Albuquerque, NM", code: "DMA:Albuquerque, NM" },
  { label: "Santa Fe, NM", code: "DMA:Santa Fe, NM" },
];

// Dedupe by code (keep first occurrence)
const _seen = new Set();
export const US_DMAS_DEDUPED = US_DMAS.filter(d => {
  if (_seen.has(d.code)) return false;
  _seen.add(d.code);
  return true;
});

// Single flat list for typeahead: United States first, then states, then DMAs (deduped)
const ALL_GEO_OPTIONS = [UNITED_STATES_OPTION, ...US_STATES.map(s => ({ ...s, type: "state" })), ...US_DMAS_DEDUPED.map(d => ({ ...d, type: "dma" }))];

/** Build code -> display label map (for tags and CSV matching) */
export function getGeoCodeToDisplay() {
  const map = { US: "United States" };
  US_STATES.forEach(s => { map[s.code] = s.label; });
  US_DMAS_DEDUPED.forEach(d => { map[d.code] = d.label; });
  return map;
}

/** Build display label (normalized) -> code for matching from CSV */
export function getGeoDisplayToCode() {
  const map = { "united states": "US" };
  US_STATES.forEach(s => { map[normalizeForMatch(s.label)] = s.code; });
  US_DMAS_DEDUPED.forEach(d => { map[normalizeForMatch(d.label)] = d.code; });
  // Also allow state abbreviations and "State" suffix
  US_STATES.forEach(s => {
    const abbr = s.code.replace("US-", "");
    map[abbr.toLowerCase()] = s.code;
    map[normalizeForMatch(s.label + " (State)")] = s.code;
  });
  US_DMAS_DEDUPED.forEach(d => {
    map[normalizeForMatch(d.label + " (DMA)")] = d.code;
  });
  return map;
}

function normalizeForMatch(str) {
  return str
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/,/g, ", ")
    .trim();
}

/** Filter options by typeahead query */
export function filterGeoOptions(query, limit = 50) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return ALL_GEO_OPTIONS.slice(0, limit);
  return ALL_GEO_OPTIONS.filter(
    opt => opt.label.toLowerCase().includes(q)
  ).slice(0, limit);
}

/** Parse CSV text (or plain newline-separated) and return array of geo codes that match states or DMAs */
export function parseGeoCSV(csvText) {
  const displayToCode = getGeoDisplayToCode();
  const codes = new Set();
  const lines = (csvText || "").split(/\r?\n/);
  for (const line of lines) {
    const cells = line.split(/[,;\t]/).map(c => c.trim()).filter(Boolean);
    for (const cell of cells) {
      const normalized = normalizeForMatch(cell);
      const code = displayToCode[normalized];
      if (code) codes.add(code);
      // Try without extra spaces (e.g. "New York" in CSV)
      const code2 = displayToCode[cell.toLowerCase().trim()];
      if (code2) codes.add(code2);
      // Try state abbreviation as standalone (e.g. "CA", "NY")
      const abbr = cell.trim().toUpperCase();
      if (abbr.length === 2 && displayToCode[abbr.toLowerCase()]) codes.add(displayToCode[abbr.toLowerCase()]);
    }
  }
  return Array.from(codes);
}

export { ALL_GEO_OPTIONS };
